import { render, staticRenderFns } from "./ScopeServiceTeamRoleForm.vue?vue&type=template&id=1739a6ae&scoped=true&"
import script from "./ScopeServiceTeamRoleForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ScopeServiceTeamRoleForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ScopeServiceTeamRoleForm.vue?vue&type=style&index=0&id=1739a6ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739a6ae",
  null
  
)

export default component.exports